import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { NumberOnlyDirective } from '../core/directives/number.directive';
import { PhoneNumberLengthDirective } from '../core/directives/phone-number-length.directive';
import { NumberOnlyStartingFromOneDirective } from '../core/directives/number-starting-from-one.directive';

@NgModule({
  declarations: [SidebarComponent, NumberOnlyDirective, PhoneNumberLengthDirective, NumberOnlyStartingFromOneDirective],
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    MatExpansionModule,
    RouterModule,
    MatTooltipModule,
    TranslateModule
  ],
  exports: [SidebarComponent, NumberOnlyDirective, PhoneNumberLengthDirective, NumberOnlyStartingFromOneDirective]
})
export class SharedModule {}
